/* 
 Markdown 主要套件
 https://github.com/remarkjs/react-markdown
 $ npm install react-markdown 
 */
import ReactMarkdown from 'react-markdown'

/*
 [plugin] 程式碼高亮
 https://github.com/react-syntax-highlighter/react-syntax-highlighter
 $ npm install @types/react-syntax-highlighter
 程式碼高亮配色(多種可選)
 https://github.com/PrismJS/prism-themes
 */
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
// import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism'// 深色.VSCode
import { vs } from 'react-syntax-highlighter/dist/esm/styles/prism'// 淺色.VS

/*
 [plugin] GitHub Flavored Markdown - GitHub上的格式，支援勾選、表格、自動生成URL連結
 https://github.com/remarkjs/remark-gfm
 $ npm install remark-gfm
 
 CSS 完全仿照 github 樣式，必須指定 "markdown-body" 才有效果。 
 附加調整 Markdown.css，目前只能使用淺色背景
 https://github.com/sindresorhus/github-markdown-css
 $ npm install github-markdown-css
 */
import remarkGfm from 'remark-gfm';
import 'github-markdown-css/github-markdown.css';

import './Markdown.css';

/* 字體大小調整 */
//import './MarkdownFontInherit.css';// 繼承上層字體大小
import './MarkdownFont.css';// 折衷 乘以 1.12 rem
//import './MarkdownFontDesktop.css'; // 桌面字體 大約要乘以 1.215 以14pt為基礎
//import './MarkdownFontMobile.css'; // 手機 1.000 rem


/** 支援 Markdown 的文字區域 */
const Markdown = ({ anchor_id = "", children = "", className = "" }) => {

    let markdown = children;

    let code_theme = vs;// undefined:預設; vs:淺色; vscDarkPlus:深色;

    let is_padding_top = markdown.startsWith("\n\n");
    let is_padding_bottom = markdown.endsWith("\n\n");

    return (
        <div>
            {/* 添加 ancher id 連結 */}
            {(anchor_id !== "" ? <a id={anchor_id} href={"#" + anchor_id} className="" style={{ visibility: "hidden", width: "0px" }}> </a> : <></>)}

            {/* Markdown 本體 */}
            <ReactMarkdown className={"markdown-body " + (is_padding_top ? " " : " pt-0") + (is_padding_bottom ? " " : " pb-0") + " " + className}
                children={markdown}
                remarkPlugins={[remarkGfm]}
                components={{
                    a: renderLink,
                    // h1: HeadingRenderer,
                    // h2: HeadingRenderer,
                    // h3: HeadingRenderer,
                    // h4: HeadingRenderer,
                    // h5: HeadingRenderer,
                    // h6: HeadingRenderer,
                    code({ node, inline, className, children, ...props }) {
                        const match = /language-(\w+)/.exec(className || '')
                        return !inline && match ? (
                            <SyntaxHighlighter
                                children={String(children).replace(/\n$/, '')}
                                style={code_theme}
                                language={match[1]}
                                PreTag="div"
                            />
                        ) : (
                            <code className={className} {...props}>
                                {children}
                            </code>
                        )
                    }
                }}

            />
        </div>
    )
}

//#region http 開頭的外網，開啟新分頁，否則在原本分頁顯示
// https://github.com/remarkjs/react-markdown/issues/12
const renderLink = (props) => {
    if (!props.href.startsWith('http')) {
        return <a href={props.href}>{props.children}</a>;
    } else {
        return <a href={props.href} rel='nofollow noreferrer noopener' target='_blank'>{props.children}</a>;
    }
};
//#endregion

//#region Add Ancher ID (官網推薦，效果不好 且中文變成減字號)
// https://github.com/remarkjs/react-markdown/issues/69
// https://github.com/remarkjs/react-markdown/issues/358
// function flatten(text: any, child: any): string {
//     return typeof child === 'string'
//         ? text + child
//         : React.Children.toArray(child.props.children).reduce(flatten, text)
// }

//#endregion


export default Markdown